import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import {
  Router,
} from '@angular/router'
import { Observable, Subscription } from 'rxjs';
import { share } from 'rxjs/operators';
import { Training } from 'src/app/models/training.model';
import { User } from 'src/app/models/user.model';
import { AuthService } from '../services/auth-service/auth.service';
import { UserLanguageService } from '../services/user-language-service/user-language.service';
import { UserDashboardService } from '../user-dashboard.service';
import { Unit } from '../../models/unit.model'
import { MatDialog } from '@angular/material/dialog';
import { UserBeforePreTestComponent } from '../pre-test/user-before-pre-test/user-before-pre-test.component';
import { TrainingSection } from 'src/app/models/training-section.model';
import { LocalStorageService } from '../services/localStorage-service/local-storage.service';
import { UserDashboardComponent } from 'src/app/layouts/user-dashboard/user-dashboard.component';
import { Test } from 'src/app/models/test.model';
import { Trainer } from 'src/app/models/trainer.model';
import { DashboardService } from '../dashboard.service';
import { NgForm } from '@angular/forms';
import { UserDocument } from 'src/app/models/userDocument.model';
import { WelcomeComponent } from '../welcome-page/welcome/welcome.component';
import {formatDate} from '@angular/common';
import {UserTestTimeupComponent} from '../user-training/user-test-timeup/user-test-timeup.component';
import {VideoScore} from "../../models/videoScore.model";

@Component({
    selector: 'app-user-training-details',
    templateUrl: './user-training-details.component.html',
    styleUrls: ['./user-training-details.component.scss'],
    host: { '(click)': 'onClick()' },
    standalone: false
})
export class UserTrainingDetailsComponent implements OnInit {

  training$: Observable<Training>
  testData: any
  currentUnit$: Observable<Unit>
  status$: Observable<Number>
  user: User
  userSub: Subscription;
  test$: Observable<Test>
  trainer
  coTrainers: Trainer[]
  userTrainingData: any

  lang
  langSub: Subscription;

  labels;
  labelsSub: Subscription;

  training: Training
  trainingSub: Subscription

  status: Number
  statusSub: Subscription

  unitsOrder$: Observable<Number>
  unitsOrder: Number
  unitsOrderSub: Subscription

  displayOverview: String = "none";
  displayDocuments: String = "none";
  displayComments: String = "block";
  displayInstructor: String = "none";
  displaySections: String = "none"

  overviewButtonClass: String = "buttonSelected";
  documentsButtonClass: String = "button";
  commentsButtonClass: String = "button";
  instructorButtonClass: String = "button";

  currentUnit: Unit
  currentUnitSub: Subscription
  currentSection: TrainingSection

  canDownloadTest: Boolean = false
  canDownloadSurvey: Boolean = false
  canDownloadStatement = false
  canDownloadCertificate = false

  comments
  trainingId
  trainingDocuments

  progress$: Observable<Number>
  progress;
  progressSub: Subscription;
  backgroundColor
  buttonStyle
  // loading = true;
  // loaded = false;
  userDocuments:UserDocument[]
  clickedComment: boolean
  clickedCouments: boolean
  trngClicked: boolean
  timeIsUp

  scores: VideoScore[]

  color1
  color2
  color3
  showSpinner: boolean = true
  disableTrainingButton: boolean = false
  @ViewChild('insertForm') insertForm:NgForm
  constructor(private dashboardService: DashboardService, private component: UserDashboardComponent, private localStorageService: LocalStorageService, public dialog: MatDialog, private router: Router, private authService: AuthService, private languageService: UserLanguageService, private userDashboarService: UserDashboardService) {
    // router.events.subscribe((event: RouterEvent) => {
    //   this.navigationInterceptor(event)
    // })

    const nav = this.router.getCurrentNavigation();
    this.timeIsUp = nav?.extras.state?.timeIsUp || false;

    console.log('time is up:', nav?.extras.state)


   }

  ngOnInit(): void {
    this.langSub = this.languageService.lang$.subscribe((lang) =>{
      this.lang = lang;
    })

    this.showSpinner = true;
    this.coTrainers = []

    this.authService.fetchCurrentUser().subscribe((user:User) => {
      this.user = user;

      setTimeout(() => {
        if(this.user.companyId == 1){
          console.log("IF")
          this.backgroundColor = "#bbbcbf"
          this.buttonStyle = "buttonEMS"
        }else if(this.user.companyId == 2){
          this.backgroundColor = "#ffe7ef"
          this.buttonStyle = "buttonECG"
        }
        else{
          this.backgroundColor = "#ffe7ef"
          this.buttonStyle = "buttonECG"
        }
        this.overviewButtonClass = ""
        this.documentsButtonClass = ""
        this.commentsButtonClass = ""
        this.instructorButtonClass = ""
        this.userDashboarService.fetchUsersDocuments(user._id).subscribe(response => {
          this.userDocuments = response as UserDocument[]
        })
        this.userDashboarService.fetchTrainingDocuments(user._id, this.localStorageService.getItem('trainingId')).subscribe(response => {
          this.trainingDocuments = response
          console.log("response")
          console.log(response)
        })
       }, 200);

      console.log('user test:', this.user)
       user.trainings.forEach(usrTr => {
        if(usrTr.trainingId == this.localStorageService.getItem('trainingId')){
          if (usrTr.status !== 3 && user.expirationDate && new Date(user.expirationDate) < new Date()){
            this.router.navigateByUrl('/user/dashboard');
          }
          this.userTrainingData = usrTr
          this.canDownloadSurvey = usrTr.surveyFlag
          this.canDownloadCertificate = usrTr.status == 3 && usrTr.successful
          this.canDownloadTest = usrTr.successful
          if(usrTr.status == 3){
            this.canDownloadStatement = true
          }
          else{
            this.canDownloadStatement = false
          }
        }
      });

    });
    this.labelsSub = this.languageService.labels$.subscribe((labels) => {
      this.labels = labels;
    })
    this.trainingSub = this.userDashboarService.training$.subscribe((training: Training) => {
      this.training = training;
      this.comments = training?.comments ?? []
      setTimeout(() => {
        if(training?.trainerId) {
          this.fetchTrainer(training.trainerId)

          for (let coTrainer of training.coTrainersIds) {
            this.dashboardService.getTrainer(coTrainer).subscribe((response) => {
              this.coTrainers.push(response as Trainer)
            })

          }
        }
        if(training.sections.length === 0) {
          this.disableTrainingButton = true;
        }

        let flag = false;
        for (let section of training.sections) {
          if(section.units.length > 0) {
            flag = true;
            break;
          }
        }

        this.disableTrainingButton = !flag;

      }, 300)

    })

    const trainingId = this.localStorageService.getItem("trainingId")
    const userTestDetailsSub = this.userDashboarService.getUserTestDetails(trainingId).subscribe((testDetails) => {
      this.testData = testDetails;
    })

    this.training$ = this.userDashboarService.getTraining().pipe(share())
    this.trainingId = this.localStorageService.getItem('trainingId');
    //this.comments = this.getComments()
    this.status$ = this.userDashboarService.getTrainingStatus().pipe(share())
    this.statusSub = this.userDashboarService.status$.subscribe((status) => {
      this.status = status;
    })

    this.clickedComment = true;
    this.clickedCouments = false;
    this.color1 = "#49D14F"
    this.color2 = "#294195";
    this.color3 = "#294195";

    this.currentUnitSub = this.userDashboarService.currentUnit$.subscribe((unit: Unit) => {
      setTimeout(() => {
        this.setCurrentUnit(unit)
        this.showSpinner = false;
    }, 1500);
    })

    this.progressSub = this.userDashboarService.progress$.subscribe((progress) => {
      this.progress = progress;
    })
    this.progress$ = this.userDashboarService.getCurrentUsersProgress(this.localStorageService.getItem('trainingId')).pipe(share())

    this.userDashboarService.fetchCurrentUsersProgressUnits(this.localStorageService.getItem('trainingId')).subscribe((progressUnits) => {
      this.scores = progressUnits;
    })
    this.unitsOrder$ = this.userDashboarService.getCurrentUnitsOrder(this.localStorageService.getItem('trainingId')).pipe(share());
    this.unitsOrderSub = this.userDashboarService.unitsOrder$.subscribe((order) => {
      this.unitsOrder = order;
      console.log("units order:", order);
    })

  }
  ngAfterViewInit() {
    console.log("AFTER INIT BRE")
    //this.showSpinner = false;
    setTimeout(() => window.scroll(0, 0), 0);

    if (this.timeIsUp) {
      const dialogRef = this.dialog.open(UserTestTimeupComponent, {
        disableClose: true,
        width: '350px'
      });

      dialogRef.afterClosed().subscribe(() => {
        console.log('The dialog was closed');

      })
    }
  }

  onActivate(event) {
    setTimeout(() => window.scroll(0, 0), 0);
  }

  ondDestroy() {
    this.userSub.unsubscribe();
    this.statusSub.unsubscribe();
  }

  @HostListener("click") onClick(){
    this.component.sideBarOpened = false
  }

  goToHomePage(){
    this.router.navigateByUrl('/user/dashboard')
  }

  goToTraining(training: Training, status: Number) {
    if(this.testData?.isBlocked || this.userTrainingData.successful) {
      // return;
    }

    console.log(training)
    console.log('test: ', this.user.trainings)
    const tr = this.user.trainings.filter((t) => t.trainingId == training._id)[0]
    console.log(tr)
    this.currentUnit$ = this.userDashboarService.getCurrentUnit(training._id).pipe(share());

    if ((!tr.pretestFlag) && training.pretestId) {
      this.localStorageService.setItem("trainingInfo", training);
      this.test$ = this.userDashboarService.getTestForTraining(this.localStorageService.getItem('pretestId')).pipe(share())
      this.router.navigateByUrl('user/start-pretest');
      console.log('ima pretest')
    }
    else {
      this.localStorageService.setItem("trainingInfo", training);
      this.router.navigateByUrl('user/training');
    }
    this.changeStatus(training, 2)

  }


  goToUnit(unit: Unit) {
    const selectedScore = this.scores.find(score => score.unit === unit._id);

    if (this.userTrainingData.status === 3 || (selectedScore?.numberOfVisits ?? 0) > 0 || unit.order === 1) {
      // Set the selected unit as the current unit
      this.localStorageService.setItem('currentUnit', unit);
      this.userDashboarService.currentUnit$.next(unit);

      this.router.navigateByUrl('user/training');
    } else {
      // Optionally, show a message to the user that they need to complete the unit before accessing it
      alert('Морате прво одслушати ову лекцију пре него што је можете отворити.');
    }

  }

  changeStatus(training: Training, status: Number){
    this.userDashboarService.changeTrainingStatus(training._id, status).subscribe((result)=>{
      console.log(result)
     })
  }

  goToTest(): void {
    this.test$ = this.userDashboarService.getTestForTraining(this.training.testId).pipe(share())
    // const dialogRef = this.dialog.open(UserBeforeTestMessageComponent, {
    //   disableClose: true,
    //   width: '350px'
    // });
    this.router.navigateByUrl('user/start-test');
  }

  goToSurvey(): void {
    this.test$ = this.userDashboarService.getSurveyForTraining(this.training.surveyId).pipe(share())
    // const dialogRef = this.dialog.open(UserBeforeTestMessageComponent, {
    //   disableClose: true,
    //   width: '350px'
    // });
    this.router.navigateByUrl('user/start-survey');
  }


  openTestDialog(): void {
    const dialogRef = this.dialog.open(UserBeforePreTestComponent, {
      disableClose: true,
      width: '350px'
    });
  }

  setCurrentUnit(unit: Unit): void {
    this.currentUnit = unit;
    //this.showSpinner = false;
  }

  fetchTrainer(id) {
    return this.dashboardService.getTrainer(id).subscribe((response) => {
      this.trainer = response as Trainer
    })
  }

  whatToDisplay(string: String) {
    switch (string) {
      case "documents":
        //divs
        this.displayOverview = "none";
        this.displayDocuments = "block";
        this.displayComments = "none";
        this.displayInstructor = "none";
        this.displaySections = "none"
        //buttons
        // this.overviewButtonClass = this.button;
        // this.documentsButtonClass = this.buttonSelected;
        // this.commentsButtonClass = this.button;
        // this.instructorButtonClass = this.button;
        this.clickedComment = false;
        this.clickedCouments = true;
        this.trngClicked = false;
        this.color1 = "#294195"
        this.color2 = "#49D14F";
        this.color3 = "#294195"
        break;
      case "comments":
        //divs
        this.displayOverview = "none";
        this.displayDocuments = "none";
        this.displayComments = "block";
        this.displayInstructor = "none";
        this.displaySections = "none"
        this.clickedComment = true;
        this.clickedCouments = false;
        this.trngClicked = false;
        this.color1 = "#49D14F"
        this.color2 = "#294195";
        this.color3 = "#294195"
        //buttons
        // this.overviewButtonClass = this.button;
        // this.documentsButtonClass = this.button;
        // this.commentsButtonClass = this.buttonSelected;
        // this.instructorButtonClass = this.button;
        break;
        case "training":
        //divs
        this.displayOverview = "none";
        this.displayDocuments = "none";
        this.displayComments = "none";
        this.displayInstructor = "none";
        this.displaySections = "block"
        this.clickedComment = false;
        this.clickedCouments = false;
        this.trngClicked = true
        this.color1 = "#294195"
        this.color2 = "#294195";
        this.color3 = "#49D14F"
        //buttons
        // this.overviewButtonClass = this.button;
        // this.documentsButtonClass = this.button;
        // this.commentsButtonClass = this.buttonSelected;
        // this.instructorButtonClass = this.button;
        break;
    }
  }

  downloadStatement(trId) {
    this.userDashboarService.downloadStatement(trId, this.lang, this.user.userName);
  }
  downloadCertificate(trId) {
    this.userDashboarService.downloadCertificate(trId, this.lang, this.user.userName);
  }
  downloadTestResults(trId) {
    this.userDashboarService.downloadTestResults(trId, this.lang, this.user.userName);
  }

  submitComment(){

    if(this.insertForm.value.text != "" && this.insertForm.value.text != null) {
      let comment = {
        userId: this.insertForm.value.userId,
        text: this.insertForm.value.text,
      }

      this.userDashboarService.submitComment(this.training._id, comment).subscribe((response) => {
        this.dashboardService.getTraining(this.training._id).subscribe((training: Training) => {
          this.comments = training.comments
        })
        console.log(response)
      })
    }

    this.insertForm.controls.text.reset()
  }

    protected readonly formatDate = formatDate;
}
